// Client setup choices (Charles, 2026-09-26). Same lists as
// apps/api/src/lib/client-fields.js — keep the two in step.
export const SAMPLE_RATES = ['48k', '44.1k']
export const BIT_DEPTHS = ['16 bit', '24 bit']
export const REMOTE_METHODS = ['Zoom', 'WebEx', 'Riverside', 'Session Link', 'ipDTL', 'Source Connect', 'Comrex']

/** "48k · 24 bit" — the way the Notion records read. */
export const audioLine = (c) => [c.sampleRate, c.bitDepth].filter(Boolean).join(' · ')
